module.exports = __webpack_public_path__ + "media/images/tabletennis-image-5b2d5f403f1489c136f67be1e6903bac.jpg";